import type { CSSProperties, ReactNode } from "react";

// Rotated bordered label — oxblood, sage, or ink variants. Used for
// "Endfassung", "Bezahlt", "Im Beta verfügbar", "Bald", "frisch", etc.

type StampVariant = "oxblood" | "sage" | "ink";

const PALETTE: Record<StampVariant, { bg: string; fg: string }> = {
  oxblood: { bg: "var(--oxblood)", fg: "var(--paper-50)" },
  sage: { bg: "var(--sage)", fg: "var(--paper-50)" },
  ink: { bg: "var(--ink)", fg: "var(--paper-50)" },
};

export default function Stamp({
  children,
  variant = "oxblood",
  rotation = -2,
  style,
}: {
  children: ReactNode;
  variant?: StampVariant;
  rotation?: number;
  style?: CSSProperties;
}) {
  const colors = PALETTE[variant];
  return (
    <span
      style={{
        display: "inline-block",
        background: colors.bg,
        color: colors.fg,
        fontFamily: "var(--f-ui)",
        fontSize: 10,
        fontWeight: 700,
        letterSpacing: "0.16em",
        textTransform: "uppercase",
        padding: "5px 10px",
        borderRadius: 4,
        transform: `rotate(${rotation}deg)`,
        ...style,
      }}
    >
      {children}
    </span>
  );
}
